export const INITIALIZE_STATIC_CONFIG = 'initializeStaticConfig'
export const SET_CONFIG = 'setConfig';
export const STATIC_CONFIG_INITIALIZED = 'STATIC_CONFIG_INITIALIZED'